// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3MDdj","title":"BackImages_title__2tdTB","images":"BackImages_images__1YjrZ"};